// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3skPE","label":"CategoryService_label__3DdGn","location":"CategoryService_location__LMTqp"};